import React from 'react';
import {observer} from 'mobx-react';
import {PredictionsOptionViewModel} from "../../../../../domain/full-game/models/prediction/predictions.option.view-model";
import {PredictionResultsOptionsItem} from "./prediction.results-options.item";
import classNames from "classnames";
import styles from "../../style/prediction.module.scss";

export const PredictionResultsOptions = observer(({prediction}) => {
  const {options} = prediction;

  return (
    <div className={classNames(styles.results_options)}>
      {
        options.map((option: PredictionsOptionViewModel) => <PredictionResultsOptionsItem key={option.num} option={option}/>)
      }
    </div>
  )
});
